import { XStack, YStack, Text, View, isWeb } from 'tamagui'
import { HeroIcon } from './HeroIcon'
import { useComponentTranslation } from '@hooks/useComponentTranslation'

export const ProcessingVideoInformative = () => {
  const { t } = useComponentTranslation('VideoPlayer')

  return (
    <View
      position={isWeb ? 'relative' : 'absolute'}
      top={0}
      left={0}
      right={0}
      bottom={0}
      backgroundColor="$cross-black"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
      zIndex={3}
      padding="$spacing-inset-md"
    >
      <XStack
        alignItems="center"
        justifyContent="center"
        gap="$spacing-inset-xs"
        paddingHorizontal="$spacing-inset-md"
      >
        <View
          width={60}
          height={60}
          borderRadius="$border-radius-pill"
          backgroundColor="rgba(255, 255, 255, 0.1)"
          justifyContent="center"
          alignItems="center"
          borderWidth="$border-width-hairline"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          <HeroIcon
            icon={['fal', 'hourglass-clock']}
            size={32}
            color="$text-on-media"
          />
        </View>

        <YStack gap="$spacing-inset-xxs">
          <Text
            fontSize="$font-size-xs"
            ff="$mulishBold"
            color="$text-on-media"
            fontWeight={700}
          >
            {t('error.playback.title')}
          </Text>

          <Text
            fontSize="$font-size-xxxs"
            ff="$mulishRegular"
            color="$text-on-media"
            lineHeight="$line-height-compact"
            maxWidth={320}
          >
            {t('error.playback.message')}
          </Text>
        </YStack>
      </XStack>
    </View>
  )
}
